import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";


async function dataStream(callback) {
  const brands = [{id:1,label:'Male',value:"Male"},{id:2,label:'Female',value:"Female"}]
  // await BrandController.getBrands(country);
  callback(sortArrayPipe.transform(brands, 'value'));
}
const GenderSelect = withBaseSelect([], dataStream);
export default GenderSelect;
